import React, { useState } from 'react'
import filterIcon from '~/assets/svgs/icon-filter.svg?react'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import {
  DropdownMangoButton,
  MangoButtonMenuItem,
} from '~/components/shared/Dropdown/DropdownMangoButton'
import { MenuPlacement } from '~/components/shared/Dropdown/Menu'

export type HeatmapDirection =
  | 'inbound'
  | 'outbound'
  | 'missed'
  | 'answered'
  | 'direction'

interface HeatmapDirectionDropdownProps {
  initialValue?: HeatmapDirection
  onSelect: (value: HeatmapDirection) => void
}

const HeatmapDirectionDropdown = ({
  initialValue = 'answered',
  onSelect,
}: HeatmapDirectionDropdownProps) => {
  const dropdownItems: MangoButtonMenuItem<string>[] = [
    { value: 'answered', content: 'Answered' },
    { value: 'direction', content: 'Direction' },
  ]

  const initialIndex = dropdownItems.findIndex(
    (item) => item.value === initialValue,
  )
  const [selectedDropdownItem, setSelectedDropdownItem] =
    useState<number>(initialIndex)

  const handleDropdownSelect = (selectedValue: string, index: number) => {
    setSelectedDropdownItem(index)
    onSelect(selectedValue as HeatmapDirection)
  }

  const selectedItemContent =
    (dropdownItems[selectedDropdownItem]?.content as string) ||
    'Default Placeholder'

  return (
    <DropdownMangoButton
      items={dropdownItems}
      selectedIndex={selectedDropdownItem}
      onSelect={handleDropdownSelect}
      variant={MangoButtonVariant.Default_200}
      placeholder={selectedItemContent}
      leftIcon={filterIcon}
      menuOptions={{
        width: '12rem',
        placement: MenuPlacement.BottomRight,
      }}
    />
  )
}

export default HeatmapDirectionDropdown
